module.exports = __webpack_public_path__ + "0c0c633ddc7e4cfe9df5110e9d437ebb.svg";